import React, { useCallback, useEffect, useState } from 'react';
import { useLive } from '../../live.jsx';
import { Link } from 'react-router-dom';
import { api } from '../../api.js';
import { useI18n, usePageTitle } from '../../i18n/index.jsx';
import { Alert } from '../../components/ui.jsx';
import MembershipTab from './MembershipTab.jsx';
import { AccountHead, useAccount } from './AccountLayout.jsx';

// Abonnement / Plan: current plan, free-access end date, product limit and
// the plans with the upgrade button (Stripe later).
export default function PlanPage() {
  const { t, errorText } = useI18n();
  const { summary, reload: reloadSummary } = useAccount();
  usePageTitle('accountNav.plan');
  const [membership, setMembership] = useState(null);
  const [error, setError] = useState('');
  const reload = useCallback(() => {
    reloadSummary();
    return api('/membership').then(setMembership).catch((e) => setError(errorText(e)));
  }, [errorText]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { reload(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useLive(['account', 'plans'], () => { reload(); });
  const limit = summary?.limit;
  return (
    <div className="acc-page">
      <AccountHead place="acc.plan" title={t('accountNav.plan')} lead={t('planPage.lead')} />
      <Alert>{error}</Alert>
      {limit && (
        <div className="acc-limit">
          <strong>{limit.max !== null ? t('productsPage.limit', { used: limit.used, max: limit.max }) : t('productsPage.noLimit', { n: limit.used })}</strong>
          <Link to="/account/products">{t('accountNav.products')} →</Link>
        </div>
      )}
      <MembershipTab membership={membership} reload={reload} />
    </div>
  );
}
